import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/projs/youstack.PNG";
import projImg2 from "../assets/projs/menubar.PNG";
import projImg3 from "../assets/projs/life.PNG";
import projImg4 from "../assets/projs/crown.PNG";
import projImg5 from "../assets/projs/emp6.PNG";
import projImg6 from "../assets/projs/virtual.PNG";

import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Youstack.co",
      description: "Educational Platform (like udemy)",
      imgUrl: projImg1,
      link:"https://youstack.netlify.app/"
    },
    {
      title: "Menubarai",
      description: "Saas",
      imgUrl: projImg2,
      link:"https://menubarai.netlify.app/"
    },
    {
      title: "Life Blossom hospital",
      description: "Medical Portal management system ",
      imgUrl: projImg3,
      link:"https://lifeblossom.netlify.app/"
    },
    {
      title: "Crown college",
      description: "Medical College school portal",
      imgUrl: projImg4,
      link:"https://crowncollege.netlify.app/"
    },
    {
      title: "Emperor6",
      description: "A gaming platform",
      imgUrl: projImg5,
      link:"https://emperor6.netlify.app/"
    },

    {
      title: "Virtual Restart",
      description: "A Software Company",
      imgUrl: projImg6,
      link:"https://virtualrestart.netlify.app/"
    },
  ];

  return (
    <section className="project" id="projects">
      <Container fluid>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p className="text-start">I've worked on several real-world and personal projects that demonstrate my full stack capabilities — from building responsive React-based frontends to developing robust Node.js/Express APIs and managing both MongoDB and MySQL databases. Notable projects include an online learning platform Youstack.co , a QR menu platform (Menubarai) that helps hotels and bars manage their services digitally, and a school admin portal for Crown Point College of Health. I've also integrated third-party APIs, handled authentication with JWT, deployed full applications to platforms like Vercel and Netlify, and worked with both modern stacks like Next.js . My projects reflect not just coding skills but also an understanding of user needs, deployment challenges, and real-time updates.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>I'm always open to exciting projects, collaborations, or full-time opportunities in web development. Whether you have an idea to build, a team to join, or just want to connect, feel free to reach out — let’s create something impactful together!</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>I'm always open to exciting projects, collaborations, or full-time opportunities in web development. Whether you have an idea to build, a team to join, or just want to connect, feel free to reach out — let’s create something impactful together!</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" alt="kjh" src={colorSharp2}></img>
    </section>
  )
}
